import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Validator function that checks if the control value is an instance of a Date object.  Will fail on a string that contains a valid date.
 * @returns 
 */
export function isDateValidator(): ValidatorFn {
    return (control: AbstractControl) : ValidationErrors | null => {
        const value = control.value

        
        if ((value instanceof Date) === false ) {
            return { isNotDate: true }
        }

        return null
    }
}